{
  "personal-data-form": {
    "text": {
      "birthday": "Narozeniny",
      "name": "Název",
      "surname": "Příjmení"
    }
  }
}
